  <!-- ═══════════════ CONFIG-DRIVEN MOBILE HEADER ═══════════════ -->
  @if (mobileSubPosition() === 'TOP' && hasMobileSubheader()) {
    <ng-container *ngTemplateOutlet="mobileSubheaderTemplate"></ng-container>
  }
  <div class="menu-top-bar tw-relative tw-flex tw-items-center" [class.guest_deposit]="guestDepositOpened">
    <app-header-overflow-row
      class="tw-self-stretch"
      [items]="mobileMainItemsFlat()"
      [isMobile]="true"
      [activeUrl]="headerActiveItemService.activeUrl()"
      [loginTemplate]="loginElement"
      [isCasinoOpened]="isCasinoOpenedMemo"
      [isLightTheme]="isLightTheme"
      [isLoggedIn]="isLoggedIn"
      [showThemeTooltip]="false"
      [hideButtonLightMode]="themeService.hideButtonLightMode()"
      [showCrmButton]="showCrmButton"
      [labelClass]="'menu-top-bar__item-option-label'"
      (itemClick)="onItemClick($event)"
      (themeToggle)="toggleTheme()"
    ></app-header-overflow-row>
  </div>

  @if (mobileSubPosition() === 'BOTTOM' && hasMobileSubheader()) {
    <ng-container *ngTemplateOutlet="mobileSubheaderTemplate"></ng-container>
  }

  <!-- Mobile subheader template -->
  <ng-template #mobileSubheaderTemplate>
    <div class="second-bar tw-flex tw-flex-row tw-items-center tw-justify-between tw-w-full">
      <app-header-overflow-row
        class="tw-self-stretch"
        [items]="mobileSubItemsFlat()"
        [isMobile]="true"
        [activeUrl]="headerActiveItemService.activeUrl()"
        [loginTemplate]="loginElement"
        [isCasinoOpened]="isCasinoOpenedMemo"
        [isLightTheme]="isLightTheme"
        [isLoggedIn]="isLoggedIn"
        [showThemeTooltip]="false"
        [hideButtonLightMode]="themeService.hideButtonLightMode()"
        [showCrmButton]="showCrmButton"
        [labelClass]="'menu-top-bar__item-option-label'"
        [inSubheader]="true"
        (itemClick)="onItemClick($event)"
        (themeToggle)="toggleTheme()"
      ></app-header-overflow-row>
    </div>
  </ng-template>

<ng-template #loginElement let-item="item">
  @if (!isLoggedIn && !guestDepositOpened && !hasCasinoGameOpened) {
    <button mat-button data-testid="header.login.button" class="mat-button-outline login-btn mobile-btn" (click)="openLoginDialog()">
      {{ item.view?.title || ('GENERAL.SIGN_IN' | translate) }}
    </button>
  }
  @if (isLoggedIn) {
    <div (click)="toggleLoginMenu()" class="logged-area tw-flex tw-flex-col tw-justify-center tw-items-start tw-h-full tw-cursor-pointer tw-gap-0.5 mobile-auth-container">
      <ng-container [ngTemplateOutlet]="loggedAreaTemplate"></ng-container>
      @if (isSmarticoEnabled && notificationsCount > 0) {
        <div class="notification-badge tw-flex tw-flex-col tw-justify-center tw-items-center tw-absolute tw-right-2 tw-top-1 tw-min-w-[14px] tw-h-3.5 tw-z-[2]">
          <span class="tw-text-center tw-not-italic tw-leading-normal">{{ notificationsCount }}</span>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #loggedAreaTemplate>
  <div class="tw-flex tw-justify-center tw-items-center tw-gap-1">
    <div class="avatar-wrapper tw-flex tw-justify-center tw-items-center tw-relative tw-w-5 tw-h-5">
      <div class="level-progress-container tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-full">
        @if (isSmarticoReady) {
          <svg class="progress-ring tw-absolute tw-z-[99] tw-rotate-90" width="18" height="18" viewBox="0 0 36 36">
            <defs>
              <filter id="progress-glow-mobile" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="2" />
                <feOffset dx="0" dy="0" result="offsetblur" />
                <feFlood flood-color="#F6921E" />
                <feComposite in2="offsetblur" operator="in" />
                <feMerge>
                  <feMergeNode />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <circle
              class="progress-ring__circle"
              stroke="#F6921E"
              stroke-width="2"
              fill="transparent"
              r="16"
              cx="18"
              cy="18"
              filter="url(#progress-glow-mobile)"
              [style.stroke-dasharray]="100.5"
              [style.stroke-dashoffset]="100.5 - (100.5 * progressPercentage) / 100"
            />
          </svg>
        }

        <div class="avatar-inner tw-rounded-full tw-overflow-hidden tw-flex tw-items-center tw-justify-center tw-z-[1]">
          @if (profile && profile.avatar_id) {
            <img [src]="getAvatarUrl(profile.avatar_id)" class="avatar-img tw-shrink-0 tw-aspect-square tw-object-cover" />
          } @else {
            <mat-icon class="material-symbols-rounded default-avatar-icon">account_circle</mat-icon>
          }
        </div>
      </div>
    </div>

    <span class="user-name tw-truncate">
      {{ smarticoDisplayName }}
    </span>
  </div>
  <div class="tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-0.5">
    <span class="user-balance tw-whitespace-nowrap">
      {{
        userBalanceWithBonus | currencycase: { hidden: hasCasinoGameOpened || (UtilsService.valuesHidden$ | async), truncateFrom: 10000000 }
      }}
    </span>
  </div>
</ng-template>
